// This component is essentially just styles with no functionality, so safe to
// ignore for coverage
/* istanbul ignore file */

import { corners, media } from "../../styles";
import styled, { css } from "styled-components";
import { applyOpacity } from "../../styles/utils";
import React from "react";
export type CheckboxProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;
const whiteCheck = css`
  content: url("data:image/svg+xml; utf8, <svg width='16' height='12' viewBox='0 0 16 12' xmlns='http://www.w3.org/2000/svg'><g id='check'><path id='Path' d='M5.59466 11.7189L0.719661 6.84392C0.42678 6.55104 0.42678 6.07616 0.719661 5.78325L1.7803 4.72259C2.07318 4.42968 2.54808 4.42968 2.84096 4.72259L6.12499 8.00659L13.159 0.97259C13.4519 0.679709 13.9268 0.679709 14.2197 0.97259L15.2803 2.03325C15.5732 2.32614 15.5732 2.80101 15.2803 3.09392L6.65532 11.7189C6.36241 12.0118 5.88754 12.0118 5.59466 11.7189V11.7189Z' fill='%23ffffff'/></g></svg>");
`;
const blackCheck = css`
  content: url("data:image/svg+xml; utf8, <svg width='16' height='12' viewBox='0 0 16 12' xmlns='http://www.w3.org/2000/svg'><g id='check'><path id='Path' d='M5.59466 11.7189L0.719661 6.84392C0.42678 6.55104 0.42678 6.07616 0.719661 5.78325L1.7803 4.72259C2.07318 4.42968 2.54808 4.42968 2.84096 4.72259L6.12499 8.00659L13.159 0.97259C13.4519 0.679709 13.9268 0.679709 14.2197 0.97259L15.2803 2.03325C15.5732 2.32614 15.5732 2.80101 15.2803 3.09392L6.65532 11.7189C6.36241 12.0118 5.88754 12.0118 5.59466 11.7189V11.7189Z' fill='%231a1a1a'/></g></svg>");
`;
const Input = styled.input.attrs({
  type: "checkbox"
})`
  // Disable default checkbox
  appearance: none;
  -webkit-appearance: none;
  position: relative;

  margin: 0px;

  height: 1.5rem;
  width: 1.5rem;
  flex-shrink: 0;

  border: 1px solid ${({
  theme
}) => theme.colours.dark};
  ${corners.m}

  &:checked {
    background: ${({
  theme
}) => theme.colours.dark};
    ::after {
      ${whiteCheck}
      position: absolute;
      left: 0.2rem;
      top: 0.3rem;
    }
  }

  @media ${media.hoverable} {
    &:hover {
      cursor: pointer;
    }
  }

  &:focus {
    outline: none;
    background: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.1)};
    &:checked::after {
      ${blackCheck}
    }
  }
`;
export function Checkbox(props: CheckboxProps) {
  return <Input {...props} data-sentry-element="Input" data-sentry-component="Checkbox" data-sentry-source-file="Checkbox.tsx" />;
}
export default Checkbox;